import { Component, OnInit, Output, EventEmitter, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { CurrentUserService } from "../../../services/shared";
import { siteAdminService } from "./siteAdmin.service";
import{Banner} from "../../../models";
import { NgProgressService }            from "ng2-progressbar";
import * as swal from "sweetalert2";

@Component({
    selector: "siteAdmin-component",
    template: require("./siteAdmin.component.html"),
    styles: [require("./siteAdmin.component.less").toString()],
    providers: [siteAdminService]
})

export class SiteAdminComponent implements OnDestroy, OnInit {
    @Output() reloadMyhome: EventEmitter<any> = new EventEmitter();
    subscriber: Subscription;
    errorMessage: string;
    activeTabId: number = 0;
    totalCount: string;
    isAdministrator: boolean;
    accountOrganisationId: string;
    banner: Banner;
    isSiteAdmin: boolean;

    constructor(private netIdRouter: Router, private siteAdminService: siteAdminService, private currentUserService: CurrentUserService,
        private pService: NgProgressService) {
        this.subscriber = siteAdminService.updateConfirmed$.subscribe(
            totalItems => { this.totalCount = " (" + totalItems + ")"; });
            this.banner = new Banner();
    }
    public ngOnInit(): void {
        this.isAdministrator = this.currentUserService.IsOrgAdmin() || this.currentUserService.IsDiocesanAdmin();
        if (this.currentUserService.token && !this.currentUserService.userInfo) {
            this.accountOrganisationId = this.currentUserService.userInfo.organisation.accountOrganisationId;
        }
        this.isSiteAdmin = this.currentUserService.IsSiteAdmin();

      this.GetBanner();
    }

  
    public setCurrentTab(tabIndex: number): void {
        this.activeTabId = tabIndex;
    };

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }
    public onRedirect(tabIndex: number): void {
        this.setCurrentTab(tabIndex);
    }

    public onSubmit() : void{
        this.pService.start();
        this.siteAdminService
            .SaveBanner(this.banner)
            .subscribe(
                response => {
              this.banner = response;
              swal({
                title: "Update Confirmed!",
                text: "Banner has been processed successfully",
                type: "success",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1500
            });
            this.pService.done();
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                    this.banner = null;
                }
                this.pService.done();
            });
           
           
    }
    
    public GetBanner(): void {
        this.pService.start();
        this.siteAdminService
            .GetBanner()
            .map(response => response.json())
            .subscribe(
                response => {
                    this.banner = response.result; 
                },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                    this.banner = null;
                }
            });

            this.pService.done();

    }

    public onReloadMyhome(): void {
        this.reloadMyhome.emit();
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/siteAdmin/siteAdmin.component.ts